(function () {
  'use strict';

  var currentStatus = (window.GZDataLayerContext && window.GZDataLayerContext.login_status) || 'guest';
  var previousStatus = sessionStorage.getItem('gz_login_status');
  sessionStorage.setItem('gz_login_status', currentStatus);

  if (currentStatus !== 'logged' || previousStatus === 'logged') return;

  window.GZAnalyticsQueue = window.GZAnalyticsQueue || [];

  // login: the account pages are on Shopify's domain, so it's detected back on the storefront
  // after being a guest earlier in this session. add_user_info is the checkout pixel's alone, logged
  // in customers included (checkout_started).
  if (previousStatus === 'guest') {
    window.GZAnalyticsQueue.push(function (GZAnalytics) {
      GZAnalytics.push({ event: 'login' });
    });
  }
})();
